/**
 * 台风预测服务接口
 * 定义接口
 */
const IEMapService = require('./IEMapService');
/**
 * @classdesc 台风预测服务接口
 * @alias G.service.ITyphoonForecastService
 * @augments G.service.IEMapService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.realtimeUrl {String} 实时台风服务地址
 * @param opts.historyUrl {String} 历史存档台风服务地址
 */
class ITyphoonForecastService extends IEMapService {
    constructor(opts) {
        super(opts);
    }

    /**
     * 获取台风实时信息
     * @param opts {Object} 
     * @param opts.tfid {String} 台风id
     * @returns  {Object}
     */
    getForecastRealtime(opts) {}
    /**
     * 获取台风信息时间序列
     * @param opts {Object} 
     * @param opts.tfid {String} 台风id
     * @returns  {Object}
     */
    getForecastTimeline(opts) {}
    /**
     * 获取台风某时间点信息
     * @param opts {Object} 
     * @param opts.tfid {String} 台风id
     * @param opts.time {String} 时间
     * @returns  {Object}
     */
    getForecastByTime(opts) {}    

}
module.exports = ITyphoonForecastService;